export const mapPortalServiceMessages = {
  CREATE_MAP: {
    SUCCESS: 'map saved successfully',
    ERROR: 'Unable to create map',
  },
  EDIT_MAP: {
    SUCCESS: 'Map settings edited successfully',
    ERROR: 'Unable to edit map',
  },
  DELETE_MAP: {
    SUCCESS: 'map deleted successfully',
    ERROR: 'Unable to delete map',
  },
  DELETE_LAYER: {
    SUCCESS: 'Layer deleted successfully',
    ERROR: 'Unable to delete Layer',
  },
  GET_ALL_MAPS: {
    ERROR: 'Unable to Fetch Maps',
  },
  GET_MAP_BY_ID: {
    ERROR: 'Unable to get Map details',
  },
  GET_MAP_LAYERS: {
    ERROR: 'Unable to get Map Layers',
  },
  GET_LAYER_BOUNDS: {
    ERROR: 'Unable to get Layer Bounds',
  },
  CREATE_DUPLICATE_LAYER: {
    ERROR: 'Unable to get Layer Bounds',
  },
  DOWNLOAD_LAYER: {
    ERROR: 'Unable to Download Layer',
  },
  DOWNLOAD_SELECTED_FEATURES: {
    ERROR: 'Unable to Download Selected Features',
  },
  FETCH_FEATURES_FROM_LAYER: {
    ERROR: 'Unable to Fetch Features',
  },
  FETCH_FEATURES_KEY_VALUE_MAPPING: {
    ERROR: 'Unable to Fetch Features Mapping',
  },
  QUERY_MAP_FEATURES: {
    ERROR: 'Unable to query map features',
  },
  EDIT_FEATURES: {
    ERROR: 'Unable to Fetch Features Mapping',
  },
  EDIT_LAYER_OPTIONS: {
    SUCCESS: 'Layer properties edited successfully',
    ERROR: 'Unable to edit layer options',
  },
  GET_LAYER_GROUPS: {
    ERROR: 'Unable to get layer groups',
  },
  CREATE_LAYER_GROUP: {
    SUCCESS: 'Layer group created successfully',
    ERROR: 'Unable to create layer group',
  },
  RENAME_LAYER_GROUP: {
    SUCCESS: 'Layer group renamed successfully',
    ERROR: 'Unable to rename layer group',
  },
  UNGROUP_LAYER_GROUP: {
    SUCCESS: 'Layer group ungrouped successfully',
    ERROR: 'Unable to ungroup layer group',
  },
  REORDER_LEGEND: {
    SUCCESS: 'Legend order updated',
    ERROR: 'Unable to update layer order. Please try again.',
  },
  EDIT_GEOSERVER_FEATURES: {
    ERROR: 'Feature Update Failed',
  },
  UPLOAD_FILE_TO_FOLDER: {
    SUCCESS_FALLBACK: 'File uploaded successfully',
    ERROR_FALLBACK: 'File upload failed',
  },
  UPLOAD_FEATURES_TO_FOLDER: {
    SUCCESS_FALLBACK: 'File uploaded successfully',
    ERROR_FALLBACK: 'File upload failed',
  },
  CREATE_LAYER_FROM_GEOJSON: {
    SUCCESS_FALLBACK: 'Layer created successfully from GeoJSON',
    ERROR_FALLBACK: 'Failed to create layer from GeoJSON',
  },
  CREATE_LAYER_FROM_FEATURES: {
    SUCCESS_FALLBACK: 'Layer created successfully from features',
    ERROR_FALLBACK: 'Failed to create layer from features',
  },
  GET_MAP_SKETCHES: {
    ERROR: 'Unable to get sketches',
  },
  CREATE_MAP_SKETCH: {
    ERROR: 'Unable to create sketch',
  },
  GET_MAP_SKETCH: {
    ERROR: 'Unable to get sketch',
  },
  EDIT_MAP_SKETCH: {
    ERROR: 'Unable to edit sketch',
  },
  DELETE_MAP_SKETCH: {
    SUCCESS: 'Sketch deleted successfully',
    ERROR: 'Unable to delete Sketch',
  },
  ADD_SKETCH_ITEMS: {
    SUCCESS: 'Sketch item added successfully',
    ERROR: 'Unable to add sketch items',
  },
  EDIT_SKETCH_ITEM: {
    SUCCESS: 'Sketch item edited successfully',
    ERROR: 'Unable to edit sketch item',
  },
  DELETE_SKETCH_ITEM: {
    SUCCESS: 'Sketch item deleted successfully',
    ERROR: 'Unable to delete sketch item',
  },
  SAVE_SKETCH: {
    SUCCESS: 'Sketch downloaded successfully',
    ERROR: 'Unable to download sketch',
  },
};
